/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/linkedin'
export default icon
